import { slugify } from './slugify';
import type { MediaItem } from '../models/types';

interface ShareUrlOptions {
  item: MediaItem;
  fullShowMode: boolean;
  continueJamsMode: boolean;
}

export function buildShareUrl({ item, fullShowMode, continueJamsMode }: ShareUrlOptions): string {
  const collection = item.extras?.collection || item.artist || '';
  const songId = item.extras?.songId || item.extras?.song_id || '';
  const showId = item.extras?.showId || item.extras?.show_id || '';
  const source = item.extras?.source || 'ls';

  let mode = 'normal';
  if (fullShowMode) {
    mode = 'fullShow';
  } else if (continueJamsMode) {
    mode = 'continueJams';
  }

  const slug = slugify(item.title || '');
  const url = new URL('https://app.liveshuffle.net');
  url.searchParams.set('share', 'true');
  url.searchParams.set('collection', collection);
  url.searchParams.set('title', slug);
  url.searchParams.set('date', item.album || '');
  url.searchParams.set('songId', songId);
  url.searchParams.set('showId', showId);
  url.searchParams.set('mode', mode);
  url.searchParams.set('source', source);

  return url.toString();
}

export function buildShareUrlPath({ item, fullShowMode, continueJamsMode }: ShareUrlOptions): string {
  const full = buildShareUrl({ item, fullShowMode, continueJamsMode });
  const parsed = new URL(full);
  return `${parsed.pathname}${parsed.search}`;
}
